import React from 'react';

/**
 * FilterTabs - Pill-style filter tabs
 *
 * Props:
 * - tabs: Array<{ id, label, count? }> - Tab definitions
 * - activeTab: string - Currently active tab id
 * - onTabChange: (tabId) => void - Tab change handler
 */
const FilterTabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <nav className="flex flex-1 flex-wrap gap-2" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          role="tab"
          aria-selected={activeTab === tab.id}
          className={`flex-1 sm:flex-initial px-2.5 py-1.5 sm:px-3 sm:py-1.5 min-h-[44px] sm:min-h-0
            text-xs sm:text-sm font-medium rounded-full transition-colors
            focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-600
            ${
              activeTab === tab.id
                ? 'bg-cyan-600 text-white'
                : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
            }`}
        >
          {tab.label}
          {typeof tab.count === 'number' && (
            <span className="ml-1.5 hidden sm:inline">({tab.count})</span>
          )}
        </button>
      ))}
    </nav>
  );
};

export default FilterTabs;